/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var CarBodyType;
(function (CarBodyType) {
    CarBodyType["Suv"] = "Suv";
    CarBodyType["Limousine"] = "Limousine";
    CarBodyType["Sport"] = "Sport";
    CarBodyType["Van"] = "Van";
    CarBodyType["Coupe"] = "Coupe";
    CarBodyType["Sedan"] = "Sedan";
    CarBodyType["Motorcycle"] = "Motorcycle";
    CarBodyType["Cabriolet"] = "Cabriolet";
    CarBodyType["StationWagon"] = "StationWagon";
    CarBodyType["Hatchback"] = "Hatchback";
    CarBodyType["Liftback"] = "Liftback";
    CarBodyType["PickUp"] = "PickUp";
})(CarBodyType || (CarBodyType = {}));
export function CarBodyTypeFromJSON(json) {
    return CarBodyTypeFromJSONTyped(json, false);
}
export function CarBodyTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function CarBodyTypeToJSON(value) {
    return value;
}
